import axios from 'axios';
import jwtService from '@/service/JwtService';

const API_URL = '/api/';

class BaseApi {
  constructor(url) {
    this.api = axios.create({
      baseURL: `${API_URL}${url}`,
    });

    this.api.interceptors.request.use(this.applyAccessToken);
  }

  combineUrls(baseURL) {
    return (request) => {
      request.url = baseURL + request.url;
      return request;
    };
  }

  async applyAccessToken(config) {
    if (config.headers.Authorization != null) {
      return config;
    }

    const jwt = await jwtService.get();
    if (jwt && jwt.token && !jwt.isExpired()) {
      config.headers.Authorization = `Bearer ${jwt.token}`;
    }
    return config;
  }
}

export { BaseApi };
export default BaseApi;
